import { render, staticRenderFns } from "./ProlificQuestionLabelling.vue?vue&type=template&id=caca73cc&scoped=true"
import script from "./ProlificQuestionLabelling.vue?vue&type=script&lang=js"
export * from "./ProlificQuestionLabelling.vue?vue&type=script&lang=js"
import style0 from "./ProlificQuestionLabelling.vue?vue&type=style&index=0&id=caca73cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caca73cc",
  null
  
)

export default component.exports